import SelectField from '../../../../FormControl/input/SelectField';
import { useSelector } from 'react-redux';

const SelectLearningAreas = ({ onChange, value, onClear, disabled, error }) => {
  const learningAreas = useSelector((state) => state?.periodicalReport?.learningAreas || []);
  const options = learningAreas.map((item) => ({
    value: item._id,
    label: item.name,
    curriculum: item.curriculum
  }));

  return (
    <SelectField
      placeholder='Choose a learning area'
      options={options}
      onChange={onChange}
      value={value}
      disabled={disabled}
      onClear={onClear}
      error={error}
      helperText={error}
      groupBy={'curriculum'}
    />
  );
};

export default SelectLearningAreas;
